import { createSelector } from "@reduxjs/toolkit";
import selectCategorizationAnnotations from "./selectCategorizationAnnotations";
import { CategorizationAnnotation } from "../../configMap/interfaces/category";
import { RootState } from "../../app";

type Props = {
  categorizationId?: string;
  documentId?: string;
  groupBlockId?: string;
  index?: number;
};

const selectCategorizationAnnotationId = createSelector(
  selectCategorizationAnnotations,
  (_: RootState, props: Props) => props,
  (categorizationAnnotations, props): CategorizationAnnotation | null => {
    const { categorizationId, documentId, index, groupBlockId } = props;
    if (!categorizationId || !documentId) {
      return null;
    }

    const found = categorizationAnnotations.find((ca) => {
      if (ca.groupBlockId !== undefined) {
        return (
          ca.documentId === documentId &&
          ca.categorizationId === categorizationId &&
          ca.groupBlockId === groupBlockId &&
          ca.index === index
        );
      }

      return (
        ca.documentId === documentId &&
        ca.categorizationId === categorizationId &&
        ca.index === index
      );
    });
    if (found) {
      return found;
    }

    return null;
  },
);

export default selectCategorizationAnnotationId;
